import React from "react";
import { Typography, TruncateTooltip, RefreshButton } from "..";
import useBreakpoints from "../hooks/useBreakpoints";
import { useStyles } from "./MainHeader.styles";
import BackNavigation from "../BackNavigation";

interface MainHeaderProps {
  title: string;
  backUrl?: string;
  subTitle?: string;
  action?: React.ReactNode;
  hideRefresh?: boolean;
}

function MainHeader(props: MainHeaderProps): JSX.Element {
  const { title, backUrl, subTitle, action, hideRefresh } = props;

  const { mdUp } = useBreakpoints();

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <BackNavigation backUrl={backUrl} className={classes.back} />
      <div className={classes.content}>
        <div className={classes.title}>
          <TruncateTooltip>
            <Typography
              variant={mdUp ? "h1" : "h2"}
              fontWeight="semiBold"
              m={0}
              color="grey"
              tone={900}
              noWrap={mdUp}
            >
              {title}
            </Typography>
          </TruncateTooltip>
          {hideRefresh !== true && (
            <div className={classes.refresh}>
              <RefreshButton />
            </div>
          )}
        </div>
        <div className={classes.subtitle}>
          <Typography color="grey" tone={700} variant="body2" display="block">
            {subTitle}
          </Typography>
        </div>
      </div>
      <div className={classes.actions}>{action}</div>
    </div>
  );
}

export default MainHeader;
